import Buttons from "../../../components/UI/Buttons";
import Progressbar from "../../../components/UI/Progressbar";
const Invoice = (props) => {
    const getProgressStyles=(value)=>{
        let pathColor='62BB46';
        if (value <= 50) {
            pathColor= '#d8423a'; // Red for 0-50
        } else if (value <= 75) {
            pathColor= '#FDA635'; // Yellow for 51-75
        } else {
            pathColor= '#62BB46'; // Green for 76-100
        }
        return {pathColor}
        
    }
    return (
        <div className="col-md-4 col-12mb-2 pb-1">
            <div className="d-flex  align-items-top w-100 sh_newdashcard cornsilk" >
                <div class="d-flex flex-column  w-100">
                    <h1 class="p1-strong mb-2">Open Invoice</h1>
                    <div class="d-flex justify-content-between">
                        <p class="p3-light text-dark mb-1">
                            <span class="mr-1">
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="12" height="12" rx="6" fill="#7D4BC5"></rect>
                                </svg>
                            </span>
                            Current
                        </p>
                        <p class="p3-light text-dark mb-1">$12000</p>
                    </div>
                    <div class="d-flex justify-content-between">
                        <p class="p3-light text-dark mb-1">
                            <span class="mr-1">
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="12" height="12" rx="6" fill="#F6447E"></rect>
                                </svg>
                            </span>
                            30+days</p>
                        <p class="p3-light text-dark mb-1">$1200</p>
                    </div>
                    <div class="d-flex justify-content-between">
                        <p class="p3-light text-dark mb-1">
                            <span class="mr-1">
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="12" height="12" rx="6" fill="#F7BCB2"></rect>
                                </svg>
                            </span>
                            60+days</p>
                        <p class="p3-light text-dark mb-1">$120</p>
                    </div>

                </div>
                <div className="w-100 d-flex justify-content-center">
                    <svg id="donutSvg" width="100" height="100" viewBox="0 0 136 136" stroke-width="6">
                        <circle class="bg" cx="68" cy="68" r="65" stroke="#f2f2f2" fill="none"></circle>

                        <circle id="seg1" class="sh_donutsegment" cx="68" cy="68" r="65" stroke="#7D4BC5" fill="none" stroke-dasharray="245.04422698000383 163.36281798666926" stroke-dashoffset="0" stroke-linecap="round"></circle>
                        <circle id="seg2" class="sh_donutsegment" cx="68" cy="68" r="65" stroke="#F6447E" fill="none" stroke-dasharray="122.52211349000191 285.88493147667117" stroke-dashoffset="-245.04422698000383" stroke-linecap="round"></circle>
                        <circle id="seg3" class="sh_donutsegment" cx="68" cy="68" r="65" stroke="#F7BCB2" fill="none" stroke-dasharray="40.840704496667314 367.5663404700058" stroke-dashoffset="-367.56634047000574" stroke-linecap="round"></circle>

                        <g class="iconGroup" fill="transparent" transform="translate(50 50)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M33.0503 6.58491L31.4041 5.75762C30.9377 5.52324 30.3883 5.52147 29.9204 5.75285L27.3057 7.04585L24.7434 5.7587C24.2757 5.52371 23.7245 5.52272 23.2559 5.75601L20.6639 7.04636L18.072 5.75601C17.6034 5.52272 17.0523 5.52371 16.5845 5.7587L14.0222 7.04585L11.4075 5.75285C10.9396 5.52147 10.3902 5.52324 9.92378 5.75762L8.27758 6.58491C7.71587 6.86715 7.36134 7.44204 7.36133 8.07068V33.0214C7.36134 33.65 7.71585 34.2249 8.27755 34.5072L9.92374 35.3345C10.3902 35.5688 10.9395 35.5706 11.4075 35.3392L14.0222 34.0462L16.5845 35.3334C17.0522 35.5684 17.6033 35.5694 18.072 35.3361L20.6639 34.0456L23.2559 35.336C23.7245 35.5693 24.2756 35.5683 24.7434 35.3333L27.3056 34.0462L29.9204 35.3392C30.3883 35.5705 30.9377 35.5688 31.4041 35.3344L33.0503 34.5071C33.612 34.2249 33.9665 33.65 33.9666 33.0213V8.07068C33.9666 7.44205 33.612 6.86716 33.0503 6.58491Z" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M27.3202 14.7259H14.0176" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M20.6656 26.3661H14.0176" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M20.665 20.5463H14.0137" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M27.3171 26.2738H25.6543" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M27.3171 20.5463H25.6543" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    );

}
export default Invoice;